export default __webpack_public_path__ + "static/media/ic_tag.31e46459.svg";